import { render, staticRenderFns } from "./ImportVehicleDialog.vue?vue&type=template&id=53fdc2d7&scoped=true"
import script from "./ImportVehicleDialog.vue?vue&type=script&lang=js"
export * from "./ImportVehicleDialog.vue?vue&type=script&lang=js"
import style0 from "./ImportVehicleDialog.vue?vue&type=style&index=0&id=53fdc2d7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53fdc2d7",
  null
  
)

export default component.exports